import { Dragger } from "@portal/BaseComponents/Upload/AntUpload";
import { styled } from "@stitches/react";


export const StyledDragger = styled(Dragger, {
  "&.ant-upload.ant-upload-drag": {
    height: "160px !important",
    backgroundColor: " var(--gray-1)",
    borderColor: "var(--gray-5)",
  },
});
